"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Block16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "block-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M4.62458153,12.9612049 C5.58624338,13.6167523 6.74836554,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,6.74836554 13.6167523,5.58624338 12.9612049,4.62458153 L4.62458153,12.9612049 L4.62458153,12.9612049 Z M3.18151268,11.5758466 L11.5758466,3.18151268 C10.5772243,2.43920939 9.33990356,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,9.33990356 2.43920939,10.5772243 3.18151268,11.5758466 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z", id: "Shape", fill: "#000000", fillRule: "nonzero" })));
}
function Block16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Block16Svg, Object.assign({}, svgProps)));
}
exports.default = Block16;
//# sourceMappingURL=Block16.js.map